import { render, staticRenderFns } from "./MR.vue?vue&type=template&id=f2351452&"
import script from "./MR.vue?vue&type=script&lang=js&"
export * from "./MR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports